// Stripe.js initialization and provider for Elements
import { loadStripe } from '@stripe/stripe-js'
import type { Stripe } from '@stripe/stripe-js'

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY

if (!publishableKey) {
  console.error(
    'VITE_STRIPE_PUBLISHABLE_KEY is not set. Stripe payments will not work.'
  )
}

// Singleton promise for Stripe.js
let stripePromise: Promise<Stripe | null> | null = null

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise && publishableKey) {
    stripePromise = loadStripe(publishableKey)
  }
  return stripePromise ?? Promise.resolve(null)
}

// Re-export for convenience
export { stripePromise }
